import React from "react";
import { Card } from "@mantine/core";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { useGetTotalDisbursements } from "../../../../hooks/queries/useTransactionQueries";
import FetchFeedback from "../../../ui/CustomFetchFeedback/CustomFetchFeedback";
import StatCard from "./statCard";
import StatCardSkeleton from "./StatCardSkeleton";
import { formatKES } from "../../../../utils/transactionutils";

export default function DisbursementsStatCard() {
  const { data, isLoading, isError, refetch } = useGetTotalDisbursements();

  if (isLoading) {
    return <StatCardSkeleton className="bg-white-50" />;
  }

  if (isError) {
    return (
      <Card className="bg-white-50 min-h-[100px] sm:min-h-[130px] flex items-center justify-center p-3 sm:p-6">
        <FetchFeedback
          message="Failed to load disbursements."
          onRetry={refetch}
          fullHeight={false}
          compact
        />
      </Card>
    );
  }

  return (
    <StatCard
      icon={<FaArrowRightArrowLeft className="w-4 h-4" />}
      label="Total Disbursements"
      value={
        <span className="break-words">
          {formatKES(data?.totalDisbursedAmount)}
        </span>
      }
      className="bg-white-50"
    />
  );
}
